import { screen } from '@/router/screenRoutes';

export default [
  // routes
  {
    ...screen('inss-proposal'),
    component: () => import('@/views/INSSList.vue'),
  },
  {
    ...screen('inss-consult'),
    component: () => import('@/views/INSSConsult.vue'),
  },
  {
    ...screen('inss-video-call'),
    component: () => import('@/views/VideoCall.vue'),
  },

  // redirects
  // ...
];
